import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import clsx from 'clsx';
import { find, get, map } from 'lodash';
import { ChangeEvent, ComponentType, useState } from 'react';
import { CheckedIcon, UncheckedIcon } from 'src/components/icons';
import { alphabetLetterByIndex } from '../../../common/utils/format-utils';
import useStyles from './styles';

interface TestQuestionsItemProps {
  className?: string;
  userAnswers?: any[];
  item: Record<string, any>;
  index?: number;
  handleChange?: (question: number, answer: number) => void;
  highlightError?: boolean;
  striped?: boolean;
  hideQuestion?: boolean;
  disabled?: boolean;
}
export const TestQuestionsItem: ComponentType<TestQuestionsItemProps> = ({
  className,
  userAnswers = [],
  item,
  index = 0,
  handleChange,
  highlightError = false,
  striped = false,
  hideQuestion = false,
  disabled = false,
}) => {
  const classes = useStyles();

  const existsAnswer = find(userAnswers, (a) => item.id === a.question);
  const [value, setValue] = useState<number | null>(parseInt(get(existsAnswer, 'userAnswer')));

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    // if (disabled) return null;
    const val = (event.target as HTMLInputElement).value;
    setValue(parseInt(val));
    handleChange && handleChange(item.id, parseInt(val));
  };

  const number = item.droppedQuestionId;

  return (
    <FormControl
      className={clsx(
        classes.root,
        className,
        disabled && [
          classes.result,
          item.isCorrect ? classes.correct : classes.wrong,
          { [classes.highlight]: !item.isCorrect && highlightError },
          { [classes.onlyAnswers]: hideQuestion },
        ]
      )}
    >
      {!hideQuestion && (
        <FormLabel
          component="h4"
          classes={{
            root: classes.question,
            focused: classes.questionFocused,
          }}
        >
          {<span>{number}.</span>} {item.title}
        </FormLabel>
      )}
      <RadioGroup
        aria-label="options"
        name="answer-options-group"
        value={value}
        onChange={onChange}
        className={clsx(classes.options, { [classes.striped]: striped })}
      >
        {map(item.answers, (answer, idx: number) => (
          <FormControlLabel
            key={idx}
            value={idx}
            control={
              <Radio
                checked={
                  (!disabled && idx === value) ||
                  (disabled && (idx === item.correctAnswer || idx === item.userAnswer))
                }
                icon={<UncheckedIcon />}
                checkedIcon={<CheckedIcon />}
                classes={{
                  root: classes.radio,
                  checked: classes.checked,
                  disabled: classes.disabled,
                }}
              />
            }
            label={`${alphabetLetterByIndex(idx)}) ${answer}`}
            disabled={disabled}
            classes={{
              root: classes.option,
              disabled: classes.disabled,
            }}
            className={clsx({
              [classes.isCorrect]:
                disabled &&
                (idx === item.correctAnswer || (idx === item.userAnswer && item.isCorrect)),
              [classes.isWrong]:
                disabled &&
                ((idx === item.userAnswer && !item.isCorrect) ||
                  (item.correctAnswer && idx !== item.correctAnswer)),
            })}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

// states:
// selectable - exam, => radio - blue
// highlight error full
// highligt radio
//
//
//
//
//
